import { FilterCondition } from "./Enums";
import moment from "moment";

const Constants = {
  dateTimeFormat: "DD.MM.YYYY HH:mm",
  dateFormat: "DD.MM.YYYY",
  timeFormat: "HH:mm",
  currentYear: moment().year(),
  currentQuarter: moment().quarter(),
  currentMonth: moment().month(),
  fullTimeFormat: "HH:mm:ss",
  yearFormat: "YYYY",
  debounceValue: 300,
  messageDuration: 5,
  hazardCategoryNotSet: 0,
  notSet: "нет данных",
  requestStatuses: {
    created: "created",
    updated: "updated",
    deleted: "deleted",
    error: "error",
    uploadSuccess: "uploadSuccess",
    downloadSuccess: "downloadSuccess",
    notifySend: "notifySend",
    rejectSend: "rejectSend",
    removeSend: "removeSend",
    pending: "pending",
  },
  statusMessage: {
    created: "Запись успешно добавлена",
    updated: "Запись успешно обновлена",
    deleted: "Запись успешно удалена",
    error: "Произошла ошибка",
    errorFile: "Произошла ошибка, файл не может быть скачен",
    uploadSuccess: "Данные успешно добавлены",
    downloadSuccess: "Данные успешно скачаны",
    notifySend: "Уведомление отправлено",
    rejectSend: "Отклонение дефекта отправлено",
    removeSend: "Удаление дефекта отправлено",
    pending:
      "Процесс обработки данных начат. Ожидайте уведомление о результате",
    downloadRequestSent: "Запрос на скачивание файла отправлен",
  },
  errorMessages: {
    nothingFound: "Ничего не найдено",
    noDeletingGroupDict:
      "Группу нельзя удалить, так как в ней содержится используемый справочник",
  },
  perPageOptions: [
    { title: "1 запись", id: 1 },
    { title: "3 записи", id: 3 },
    { title: "5 записей", id: 5 },
    { title: "10 записей", id: 10 },
    { title: "25 записей", id: 25 },
    { title: "50 записей", id: 50 },
    { title: "100 записей", id: 100 },
  ],
  perPageInitialValue: 5,
  showSearchCount: 8,
  referenceDefectId: 14136,
  fileFormats: {
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "text/csv": "csv",
  },
  permissionActions: {
    0: "Чтение",
    1: "Запись",
    2: "Обновление",
    4: "Удаление",
  },
  formConstructorFieldTypeFilterCondition: {
    0: FilterCondition.Like,
    1: FilterCondition.Equal,
    2: FilterCondition.Equal,
    3: FilterCondition.Between,
    4: FilterCondition.Between,
    5: FilterCondition.Between,
    6: FilterCondition.Like,
    7: FilterCondition.Equal,
    8: FilterCondition.Equal,
    9: FilterCondition.Equal,
    10: FilterCondition.Equal,
    11: FilterCondition.Like,
    13: FilterCondition.Equal,
  },
  listOfMonth: {
    1: "January",
    2: "February ",
    3: "March",
    4: "April",
    5: "May",
    6: "June ",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December",
  },
  titleIcons: {
    edit: "Редактировать",
    add: "",
    minus: "",
    delete: "Удалить",
    eye: "Посмотреть",
    visible: "Посмотреть",
    search: "Поиск",
    info: "Справочная информация",
    history: "История",
    print: "Печать",
    view: "Смена вида",
    trash: "Удалить",
    profile: "Профиль",
    exit: "Выйти из системы",
    alert: "Уведомления",
    settingsFilter: "Настройка фильтров",
    xls: "",
    sorting: "Сортировать",
    arrow: "",
    files: "",
    back: "",
    setting: "Настройка",
    directory: "Сравнить",
    update: "Обновить",
  },
  emptyValue: "-",
  sortDirAsc: "ascend",
  sortDirDesc: "descend",
};

export default Constants;
